export default {"src":"/_next/static/media/twitter-orange.5fec0ed7.svg","height":32,"width":32};